import styled from 'styled-components';
import {textSizes, headingSizes} from '@stencil/build-theme';

export const Wrapper = styled.div`
  background-color: ${props => props.theme.colors.goWhite.base};
  padding: 2rem;
  border-radius: 2rem;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  margin-right: 0.2rem;
`;
export const HeaderTitle = styled.p`
  ${textSizes.LargeW3};
  color: #222222;

  span {
    ${textSizes.LargeW3};
    color: #007e7d;
  }
`;

export const CloseButton = styled.div``;

export const DetailsCard = styled.div`
  margin-top: 1.6rem;
  display: flex;
  flex-direction: column;
  border: 0.1rem solid #e4e4e4;
  border-radius: 1.6rem;
  margin-bottom: 2rem;
  background: radial-gradient(75.36% 140.35% at 100% 0%, #d3e7ff 0%, #ffffff 100%),
    linear-gradient(0deg, #ffffff, #ffffff);
`;

export const CardTitle = styled.p`
  ${textSizes.MediumW3};
  color: #000000;
  padding: 1.6rem 1.2rem 1.2rem 1.2rem;
  border-bottom: 0.1rem solid #e4e4e4;

  span {
    text-decoration: line-through;
  }
`;

export const DetailsSection = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: space-between;
  padding: 1.2rem 1.6rem 1.6rem 1.2rem;
`;
export const ThingsNotAvailableSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.9rem;
  flex: 1;
`;
export const NonRefundableSection = styled.div`
  display: flex;
  gap: 0.2rem;

  .close {
    width: 1.6rem;
    height: 1.6rem;
    padding: 1rem;
    display: block;
    position: relative;
    margin-right: 0.4rem;
  }
  .close:before,
  .close:after {
    position: absolute;
    top: 0.2rem;
    left: 0.8rem;
    content: ' ';
    height: 1rem;
    width: 0.2rem;
    background-color: #ec2127;
  }

  .close:before {
    transform: rotate(45deg);
  }
  .close:after {
    transform: rotate(-45deg);
  }
`;
export const NRText = styled.span`
  color: #222222;
  ${textSizes.BaseW1};
`;
export const NoMealsSection = styled.div`
  display: flex;

  .close {
    width: 1.6rem;
    height: 1.6rem;
    padding: 1rem;
    display: block;
    position: relative;
    margin-right: 0.4rem;
  }
  .close:before,
  .close:after {
    position: absolute;
    top: 0.2rem;
    left: 0.8rem;
    content: ' ';
    height: 1rem;
    width: 0.2rem;
    background-color: #ec2127;
  }

  .close:before {
    transform: rotate(45deg);
  }
  .close:after {
    transform: rotate(-45deg);
  }
`;
export const NoMealText = styled.span`
  ${textSizes.BaseW1};
`;

export const IconImage = styled.img`
  width: 12px;
  height: 12px;
  margin-top: 0.2rem;
`;

export const PricingSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  flex: 1;
  justify-content: flex-end;
`;
export const Price = styled.p`
  text-align: right;
  ${textSizes.MediumW3};
  color: #18a160;
`;
export const Taxes = styled.p`
  ${textSizes.SmallW1};
  color: #717171;
  text-align: right;
`;
export const OrignalPrice = styled.p`
  ${textSizes.SmallW2};
  color: red;
  text-align: right;
`;

export const ImportantNote = styled.p`
  ${textSizes.BaseW1};
  color: #717171;
  margin-top: 2rem;
`;

export const CTASection = styled.div`
  display: flex;
  justify-content: end;
  margin-top: 2rem;
`;
export const CTABtn = styled.button`
  width: 22rem;
  background-color: #ff6d38;
  border-radius: 0.4rem;
  padding: 1.2rem 2.4rem;
  text-align: center;
  ${textSizes.LargeW2};
  color: #ffffff;
  cursor: pointer;
`;
